import React from "react";
import BackgroundLayer from "./BackgroundLayer";
import "../../styles/components/layout/AppShell.css";

export default function AppShell({ children }) {
  return (
    <div className="app-shell">
      <BackgroundLayer />
      <div className="app-ui">
        <main className="app-content">{children}</main>
      </div>
    </div>
  );
}